import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createTRPCClient, httpBatchLink } from '@trpc/client';
import type { TalentAppRouter } from '@nemo/api';
import { ToastProvider } from '../ui/Toast.js';
import { TalentApp } from './TalentApp.js';
import { TalentTRPCProvider } from './trpc.js';
import '../index.css';
import './talent.css';

const queryClient = new QueryClient();
// Vite proxies /trpc to the talent api in development; in production that api
// serves this bundle itself, so the same relative URL works either way.
const trpcClient = createTRPCClient<TalentAppRouter>({
  links: [httpBatchLink({ url: '/trpc' })],
});

const container = document.getElementById('root');
if (container === null) throw new Error('missing #root');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TalentTRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <ToastProvider>
          <TalentApp />
        </ToastProvider>
      </TalentTRPCProvider>
    </QueryClientProvider>
  </StrictMode>,
);
